module.exports = __webpack_public_path__ + "static/media/location-point.7fe95108.svg";